














































import { Component, Mixins } from "vue-property-decorator";
import { GlobalMixin } from "@/mixins/global";

@Component
export default class UpdatePwa extends Mixins(GlobalMixin) {
  timeout = -1;
  // eslint-disable-next-line
  public registration: any;
  public refreshing = false;
  public enable = false;

  mounted() {
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.refreshing) return;
      this.refreshing = true;
      window.location.reload();
    });
  }
  // eslint-disable-next-line
  public showRefreshUI(e: any) {
    this.registration = e.detail;
    this.enable = true;
  }
  public refreshApp() {
    this.enable = false;
    if (!this.registration) {
      return;
    }

    this.registration.waiting.postMessage("skipWaiting");
  }
}
